module.exports = __webpack_public_path__ + "img/account-activation-account-created.58ba3642.svg";